const romanNumerals = {
  1: 'I',
  4: 'IV',
  5: 'V',
  9: 'IX',
  10: 'X',
  40: 'XL',
  50: 'L',
  100: 'C',
  400: 'CD',
  500: 'D',
  900: 'CM',
  1000: 'M',
}

export function getRomanNumeral (number) {
  return Object.keys(romanNumerals).reduceRight((numeral, value) => {
    while (number - parseInt(value) >= 0) {
      number -= parseInt(value)
      numeral += romanNumerals[value]
    }

    return number === 0 && !numeral ? '0' : numeral
  }, '') || ''
}


// WEBPACK FOOTER //
// ./src/utils/getRomanNumeral.js